<template>
  <div class="sykt wid-1200" id="sykt">
    <ContentTitle title="素养课堂" :hideMore="true"></ContentTitle>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in labelList" :key="item.id">
        <span slot="label">{{ item.columnName }}</span>
        <el-empty v-if="!data.length"></el-empty>
        <template v-else>
          <!-- <div class="video-container big">
            <template v-if="!isLogin">
              <img :src="bigimagehttpurl" alt="" class="poster" />
              <div class="video-controls">
                <img
                  src="../../assets/images/player.png"
                  alt=""
                  class="play-icon" @click="login()"
                />{{ videoTitle }}
              </div>
            </template>
            <video v-else :src="src" :poster="`${bigimagehttpurl}`" controls="controls" width="637" height="477" style="object-fit:cover;"></video>
          </div> -->
          <el-pagination v-if="false"
            v-show="!loading && data.length"
            :current-page.sync="pageIndex"
            hide-on-single-page
            :page-size.sync="pageSize"
            layout="prev, next"
            :total="total"
            @current-change="changePage"
          />
          <div class="list-out" v-loading="loading" v-if="false">
            <ul :class="{'list':true,'changePrev':slidePrev,'changeNext':slideNext}">
              <li v-for="(it, index) in data" :key="index" :class="{'sykt_cont1':true,'cur':cur === index}" @click="videoItem(it,index)">
                <div class="u-l">
                  <img :src="it.smallimagehttpurl" alt="" />
                </div>
                <div class="syktsp_detail u-l">
                  <h5 :title="it.videoTitle" class="text-ellipsis">{{ it.videoTitle }}</h5>
                  <p>主讲人：<span>{{ it.speakerInfo && it.speakerInfo.expertName }}</span></p>
                  <p>主办单位：<span>{{ it.orgUnit }}</span></p>
                </div>
              </li>
            </ul>
        </div>
        <el-carousel @change="carouselChange"
          height="400px"
          :loop="false"
          :autoplay="false"
          arrow="always"
          indicator-position="none"
        >
          <el-carousel-item v-for="(item, index) in data" :key="index">
            <ul class="list">
              <li v-for="(it, index) in item" :key="index" :class="{'sykt_cont1':true,'cur':cur===index}" @click="videoItem(it,index)">
                <div class="u-l">
                  <img :src="it.smallimagehttpurl" alt="" />
                </div>
                <div class="syktsp_detail u-l">
                  <h5>{{ it.videoTitle }}</h5>
                  <p>主讲人：<span>{{ it.speakerInfo && it.speakerInfo.expertName }}</span></p>
                  <p>主办单位：<span>{{ it.orgUnit }}</span></p>
                </div>
              </li>
            </ul>
          </el-carousel-item>
        </el-carousel>
      </template>
      </el-tab-pane>
    </el-tabs>
    
    <VideoContainer
          ref="videoContainer1"
          :item="item"
          :downloadUrl="downloadUrl"
          isSYKT="true"
        ></VideoContainer>
  </div>
</template>

<script>
import ContentTitle from "../../components/ContentTitle.vue";
import Cookies from 'js-cookie'
import VideoContainer from "../Video1.vue";
export default {
  props: ["downloadUrl"],
  data() {
    return {
      activeName: "0",
      cur: 0, // 当前正在播放的哪个视频
      oldCur: 0,
      src:'', // 当前正在播放的视频src
      videoTitle:'', // 当前正在播放的视频标题
      bigimagehttpurl:'', // 当前正在播放的视频封面图
      labelList:[],
      item: {
        id: 16,
        title: "习近平关于全面从严治党重要论述",
        url: "https://cnki-vod-1258158163.cos.ap-beijing.myqcloud.com/straight/452/ts/1d60b1753cd8438d8c968f536c23f22d/720p/1d60b1753cd8438d8c968f536c23f22d_720P.m3u8",
        host_unit: "中央党校（国家行政学院）",
        speaker__name: "祝灵君",
        photo: "",
        total_hours: "01:34:04",
        photo_big: "cover_big/cong_yan_zhi_dang.png",
      },
      data: [],
      isLogin: false,
      loading:false,
      pageIndex:1,
      oldPageIndex:1,
      pageSize:3,
      total:0,
      slidePrev:false,
      slideNext:false,
    };
  },
  components: {
    ContentTitle,
    VideoContainer,
  },
  mounted() {
    this.getLabelList() // 素养课堂
    this.isLogin = !!Cookies.get("user_name");
  },
  methods: {
    carouselChange(i){
      this.pageIndex = i + 1
      setTimeout(() => {
        if(i!==this.oldPageIndex-1) this.cur = 5
        else this.cur = this.oldCur
      },200)
    },
    getLabelList() {
      this.axios.get(`data/custom/classType?uid=8a9973ac-8978-4c4a-8f8c-db07dcc11ac0&pageNum=1&pageSize=10`).then((res) => {
        if (res.status == 200) {
          this.labelList = res.data.rows
          this.getData()
        } else {
          this.$message.error("获取失败！");
        }
      });
    },
    getData(total){
      this.loading = true
      this.axios.post("data/custom/videolist",{
        uid: this.labelList[Number(this.activeName)].uid,
        pageNum: this.pageIndex,
        pageSize: total || 1,
        sign:'更多'
      }).then((res) => {
        this.loading = false
        if (res.status == 200) {
          if(this.pageIndex==1 && !total) this.total = res.data.total
          if(this.total > 1 && !total) return this.getData(this.total)
          let data = res.data.rows;
          let newList = [];
          for (var i = 0; i < data.length; i += 3) {
            newList.push(data.slice(i, i + 3));
          }
          this.data = newList
          // this.data = res.data.rows
          this.src = res.data.rows[0].videoLink
          this.bigimagehttpurl = res.data.rows[0].bigimagehttpurl
          this.videoTitle = res.data.rows[0].videoTitle
          this.item = res.data.rows[0]
          this.$nextTick(() => {
            this.$refs.videoContainer1.changeMedia(this.item)
          })
        } else {
          this.$message.error("获取失败！");
        }
      });
    },
    changePage(n){
      if(n<this.pageIndex) {
        this.slideNext = false
        this.slidePrev = true
      } else {
        this.slidePrev = false
        this.slideNext = true
      }
      n===this.oldPageIndex ? this.cur = this.oldCur : this.cur = 4
      this.pageIndex = n
      setTimeout(() => {
        this.slidePrev = false
        this.slideNext = false
      },20000)
      this.getData()
    },
    videoItem(item,i){
      this.oldPageIndex = this.pageIndex
      this.oldCur = i
      this.cur = i
      // this.$refs.videoContainer1.dispose()
      this.item = item
      this.src = item.videoLink
      this.bigimagehttpurl = item.bigimagehttpurl
      this.videoTitle = item.videoTitle
      this.$refs.videoContainer1.changeMedia(item)
    },
    handleClick(tab, event) {
      this.cur = 0
      this.oldCur = 0
      this.pageIndex = 1
      this.oldPageIndex = 1
      this.getData()
    },
    login(){
      this.$message.warning('请登录后观看！')
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-pagination{
    padding: 0 20px 0 10px;
    .btn-prev,.btn-next{
      height: 100%;
      color: #bd1a2d;
      padding: 0;
      .el-icon{
        font-size: 36px;

      }
    }
    button:disabled{
      color: #ffbaba;
    }
    .btn-prev{
    background: linear-gradient(
        270deg,
        rgba(255, 233, 235, 0) 0%,
        #ffe9eb 100%
      );
    }
    .btn-next{
      position: absolute;
      right: 0;
      background: linear-gradient(
        270deg,
        #ffe9eb 0%,
        rgba(255, 233, 235, 0) 100%
      );
    }
  }
  .el-carousel {
    transform: translateX(30px);
    padding: 0 37px;
    flex: 1;
  }
  .el-carousel__arrow {
    color: #bd1a2d;
    font-size: 36px;
    border-radius: 0;
    width: 30px;
    height: 100%;
    transition: none;
    &[style="display: none;"]{
      display: block !important;
      color: #ffbaba;
      cursor: not-allowed;
      i{
        cursor: not-allowed;
      }
    }
  }
  .el-carousel__arrow--left {
    left: -37px;
    background: linear-gradient(
      270deg,
      rgba(255, 233, 235, 0) 0%,
      #ffe9eb 100%
    );
  }
  .el-carousel__arrow--right {
    right: -7px;
    background: linear-gradient(
      270deg,
      #ffe9eb 0%,
      rgba(255, 233, 235, 0) 100%
    );
  }
  // .el-carousel__item{
  //   width: calc(100% - 28px);
  // }
  .el-tabs__nav-wrap::after {
    content: none;
  }
  .el-tabs__active-bar {
    display: none;
  }
  .el-tabs__item {
    font-size: 18px;
    &:hover {
      color: #bd1a2d;
    }
  }
  .el-tabs--top {
    .el-tabs__item {
      height: 50px;
      line-height: 50px;
      padding: 0 35px;
      background: #ffe9eb;
      color: #bd1a2d;
      & + .el-tabs__item {
        margin-left: 20px;
      }
      &.is-top {
        &:nth-child(2) {
          padding-left: 25px;
        }
        &:last-child {
          padding-right: 25px;
        }
      }
      &.is-active {
        color: #fff;
        background: linear-gradient(90deg, #bd1a2d 0.09%, #ec0e0e 100%);
      }
    }
  }
  .el-tabs__content{
    width: 513px;
    float: right;
    margin-left: 10px;
  }
  .el-tabs__nav-wrap.is-scrollable {
    padding: 0 80px;
  }
  .el-tabs__header {
    margin-bottom: 25px;
  }
  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    width: 60px;
    text-align: center;
    height: 60px;
    line-height: 60px;
    background: #bd1a2d;
    color: #fff;
    font-size: 36px;
    &.is-disabled {
      background: #ffe9eb;
      color: #ffbaba;
      cursor: not-allowed;
    }
  }
  .el-tab-pane{
    display: flex;
  }
  .sykt_cont1 {
    width: 400px;
    overflow: hidden;
    margin-bottom: 10px;
    box-sizing: border-box;
    padding: 11px;
    background: #f5f5f5;
    cursor: pointer;
    &:last-of-type{
      margin-bottom: 0;
    }
    &.cur{
      background: #BD1A2D;
      .syktsp_detail {
      h5,p{
        color: #fff;
      }
      }
    }
    img {
      width: 160px;
      height: 100px;
    }
    .syktsp_detail {
      margin-left: 10px;
      width: calc(100% - 170px);
      white-space: pre-wrap;
      h5 {
        font-weight: normal;
        font-size: 16px;
        color: #000000;
        margin-bottom: 10px;
      }
      p {
        color: #898989;
        line-height: 24px;
        font-size: 12px;
      }
    }
  }

  .sykt {
    width: 1200px;
    height: auto;
    overflow: hidden;
    margin: 30px auto;
    .sykt_nav {
      margin-top: 30px;
      height: 60px;
      display: flex;
      justify-content: space-between;
      i {
        display: inline-block;
        width: 60px;
        height: 60px;
      }
      li {
        padding: 13px 25px;
        background: #ffe9eb;
        font-size: 24px;
        color: #bd1a2d;
        font-weight: 400px;
        line-height: 35px;
      }
      .sykt_on {
        color: #ffffff;
        background: linear-gradient(90deg, #bd1a2d 0.09%, #ec0e0e 100%);
      }
    }
    .sykt_cont {
      display: flex;
      justify-content: space-between;
      height: 477px;
      margin-top: 45px;
      .sykt_contlf {
        margin-right: 10px;
      }

      .sykt_contrt {
        width: 537px;
        display: flex;
        .sykt_arrlf {
          width: 30px;
          height: 475px;
          margin-right: 5px;
          background: url("../../assets/images/sykt_arrbg.png") no-repeat;
          .sykt_arr_lf {
            font-size: 2.5em;
            color: #ffbaba;
            text-indent: -3px;
            line-height: 475px;
          }
          .sykt_arr_rf {
            font-size: 2.5em;
            line-height: 475px;
            text-indent: -5px;
            color: #bd1a2d;
          }
        }
        .sykt_arrrf {
          margin-left: 5px;
          background: url("../../assets/images/sykt_arrbg2.png") no-repeat;
        }
      }
    }
  }
}
.swiper-container{
  height: 400px;
}
.list-out{
  width: 400px;
  overflow: hidden;
}
.list{
  transition: all 2s;
  // transform: translateX(-400px);
  &.changePrev{
    transform: translateX(400px);
  }
  &.changeNext{
    transform: translateX(-400px);
  }
}
.sykt{
  position: relative;
  .video-container{
    left: 0;
    top: 185px;
  }
}
</style>